import { FormDragDrop, FormLayoutColumn } from "../../models/form.models";
import { getFormRecord, updateFormRecord } from "../forms.utility";

async function getFormDragDrop(formId?: string): Promise<FormDragDrop> {
    let formRecord = await getFormRecord(formId);
    let formDragDrop = new FormDragDrop(formRecord);

    let layoutIdentifiers = formDragDrop.jHtml.find("layout").text().split(",");
    for (const layoutIdentifier of layoutIdentifiers) {
        let layoutValues = extractLayoutValues(layoutIdentifier);
        let rowItem = formDragDrop.layoutRows[layoutValues.rowNumber - 1];
        if (rowItem == null) {
            rowItem = [];
            formDragDrop.layoutRows.push(rowItem);
        }

        let columnItem = rowItem[layoutValues.columnNumber - 1];
        if (columnItem == null) {
            columnItem = new FormLayoutColumn();
            rowItem.push(columnItem);
        }

        // setup column object
        columnItem.width = layoutValues.widthNumber;
        columnItem.jHtml = formDragDrop.jHtml.find("#Section_" + layoutIdentifier);
    }

    return formDragDrop;
}

async function addRow(numberOfColumns: number, formId?: string) {
    let formDragDrop = await getFormDragDrop(formId);
    let widthNumber = getWidthNumber(numberOfColumns);
    let newRow: FormLayoutColumn[] = [];
    for (let i = 1; i <= numberOfColumns; i++) {
        let newColumn = new FormLayoutColumn();
        newColumn.width = widthNumber;

        newRow.push(newColumn);
    }
    formDragDrop.layoutRows.push(newRow);

    formDragDrop.updateLayout();
    await updateFormRecord(formDragDrop.data);
}

async function updateRow(rowNumber: number, numberOfColumns: number, formId?: string) {
    let formDragDrop = await getFormDragDrop(formId);
    let widthNumber = getWidthNumber(numberOfColumns);

    // find the row and update the existing columns and add the missing ones
    let rowItem = formDragDrop.layoutRows[rowNumber - 1];
    if (rowItem == null) {
        throw new Error("Row not found");
    }
    for (let i = 1; i <= numberOfColumns; i++) {
        let columnItem = rowItem[i - 1];
        if (columnItem == null) {
            columnItem = new FormLayoutColumn();
            rowItem.push(columnItem);
        } else {
            // update the existing column's html
            columnItem.jHtml.attr("id", `Section_${formDragDrop.getLayoutIdentifier(rowNumber, i, widthNumber)}`);
            columnItem.jHtml.removeClass("col-md-" + columnItem.width).addClass("col-md-" + widthNumber);
        }
        columnItem.width = widthNumber;
    }

    // remove any extra columns, remove from html as well
    let removedColumns = rowItem.splice(numberOfColumns);
    for (const column of removedColumns) {
        column.jHtml.remove();
    }
    if (removedColumns.length == 0) {
        // this means columns were added, find all missing columns and add them to the html
        for (let i = 0; i < rowItem.length; i++) {
            const column = rowItem[i];
            if (column.jHtml == null) {
                let jParent = rowItem[i-1].jHtml.parent();
                let identifier = formDragDrop.getLayoutIdentifier(rowNumber, i + 1, widthNumber);
                let jHtml = jQuery(`<div id="Section_${identifier}" class="col-md-${widthNumber} col-sm-12"></div>`);
                
                jParent.append(jHtml);
                column.jHtml = jHtml;
            }
        }
    }

    formDragDrop.updateLayout();
    await updateFormRecord(formDragDrop.data);
}

async function deleteRow(rowNumber: number, formId?: string) {
    let formDragDrop = await getFormDragDrop(formId);

    // find the row and remove the row itself
    let rowItem = formDragDrop.layoutRows[rowNumber - 1];
    if (rowItem == null) {
        throw new Error("Row not found");
    }
    // get the first column's html and delete the parent row
    let firstColumnItem = rowItem[0];
    firstColumnItem.jHtml.parent().remove();
    
    // update existing rows with their new row number
    for (let i = rowNumber; i < formDragDrop.layoutRows.length; i++) {
        let rowItem = formDragDrop.layoutRows[i];
        for (let j = 0; j < rowItem.length; j++) {
            let columnItem = rowItem[j];
            // i is not incremented because it sets the row back one value properly
            let identifier = formDragDrop.getLayoutIdentifier(i, j + 1, columnItem.width);
            columnItem.jHtml.attr("id", `Section_${identifier}`);
        }    
    }
    
    formDragDrop.layoutRows = formDragDrop.layoutRows.filter((rowItem, index) => index != rowNumber - 1);
    formDragDrop.updateLayout();
    await updateFormRecord(formDragDrop.data);
}

function extractLayoutValues(layoutString) {
    let regex = /R(\d+)C(\d+)W(\d+)/g;
    let match = regex.exec(layoutString);
    let rowNumber = Number.parseInt(match[1]);
    let columnNumber = Number.parseInt(match[2]);
    let widthNumber = Number.parseInt(match[3]);

    return { rowNumber, columnNumber, widthNumber };
}

function getWidthNumber(numberOfColumns: number) {
    return Math.floor(12 / numberOfColumns);
}

export {
    getFormDragDrop,
    addRow,
    updateRow,
    deleteRow
};
